import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import ReactHtmlParser from "react-html-parser"

import Layout from "../components/Layout"
import LatestBlogPosts from "../components/LatestBlogPosts"
import Seo from "../components/Seo"
import PortfolioBlock from "../components/PortfolioBlock"
import AdvantagesIconsBlock from "../components/AdvantagesIconsBlock"
import PertnershipBlock from "../components/PartnershipBlock"

const Page = ({ data }) => {
  const seoTitle = data?.nodePage?.metatag.find(
    tag => tag.attributes.name === "title"
  )?.attributes.content

  const seoDescription = data?.nodePage?.metatag.find(
    tag => tag.attributes.name === "description"
  )?.attributes.content

  const seoKeywords = data?.nodePage?.metatag.find(
    tag => tag.attributes.name === "keywords"
  )?.attributes.content

  const pageBody = new ReactHtmlParser(data?.nodePage?.body?.value, {
    transform: function transform(node) {
      if (node.type === "tag" && node.name === "img") {
        const imageFile = data?.allFileFile?.edges.find(
          edge => edge?.node?.uri?.url === node?.attribs?.src
        )

        if (imageFile?.node?.localFile) {
          return (
            <GatsbyImage
              image={
                imageFile?.node?.localFile?.childImageSharp?.gatsbyImageData
              }
            />
          )
        }
      }
      return undefined
    },
  })

  const isFrontPage = data?.nodePage?.path?.alias === "/home"

  return (
    <Layout my={[3, 4]} isFrontPage={isFrontPage}>
      <Seo
        {...(seoTitle && { title: seoTitle })}
        {...(seoDescription && { description: seoDescription })}
        {...(seoKeywords && { keywords: seoKeywords })}
        path={isFrontPage ? "/" : data?.nodePage?.path?.alias}
      />
      {isFrontPage && <PortfolioBlock />}
      {isFrontPage && <PertnershipBlock />}
      {isFrontPage && <AdvantagesIconsBlock />}
      <h2>{data?.nodePage?.title}</h2>
      {pageBody}
      {isFrontPage && <LatestBlogPosts />}
    </Layout>
  )
}

export default Page

export const query = graphql`
  query($id: String!) {
    nodePage(id: { eq: $id }) {
      title
      metatag {
        attributes {
          name
          content
        }
      }
      body {
        value
      }
      path {
        alias
      }
    }
    allFileFile {
      edges {
        node {
          drupal_id
          uri {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`
